module.exports = __webpack_public_path__ + "img/success.766f02b5.png";